import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface Purchase {
  name: string;
  city: string;
  timeAgo: string;
}
const purchases: Purchase[] = [{
  name: 'Jessica N.',
  city: 'Miami, FL',
  timeAgo: 'hace 2 minutos'
}, {
  name: 'Sarah M.',
  city: 'New York, NY',
  timeAgo: 'hace 5 minutos'
}, {
  name: 'Emily R.',
  city: 'Los Angeles, CA',
  timeAgo: 'hace 3 minutos'
}, {
  name: 'Amanda K.',
  city: 'Houston, TX',
  timeAgo: 'hace 7 minutos'
}, {
  name: 'Jennifer L.',
  city: 'Chicago, IL',
  timeAgo: 'hace 4 minutos'
}, {
  name: 'Michelle P.',
  city: 'Phoenix, AZ',
  timeAgo: 'hace 6 minutos'
}, {
  name: 'Lisa T.',
  city: 'San Diego, CA',
  timeAgo: 'hace 8 minutos'
}, {
  name: 'Karen W.',
  city: 'Dallas, TX',
  timeAgo: 'hace 5 minutos'
}, {
  name: 'Rebecca H.',
  city: 'Atlanta, GA',
  timeAgo: 'hace 3 minutos'
}, {
  name: 'Nicole B.',
  city: 'Seattle, WA',
  timeAgo: 'hace 9 minutos'
}, {
  name: 'Maria E.',
  city: 'Orlando, FL',
  timeAgo: 'hace 4 minutos'
}, {
  name: 'Sofia L.',
  city: 'San Antonio, TX',
  timeAgo: 'hace 6 minutos'
}, {
  name: 'Isabella G.',
  city: 'San Jose, CA',
  timeAgo: 'hace 2 minutos'
}, {
  name: 'Camila R.',
  city: 'Austin, TX',
  timeAgo: 'hace 5 minutos'
}, {
  name: 'Valentina M.',
  city: 'Las Vegas, NV',
  timeAgo: 'hace 8 minutos'
}];
export function PurchaseNotification() {
  const [currentPurchase, setCurrentPurchase] = useState<Purchase | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    // Show first notification after 3 seconds
    const initialTimeout = setTimeout(() => {
      setCurrentPurchase(purchases[0]);
      setIsVisible(true);
    }, 3000);
    // Set up recurring cycle - 20 seconds total (6s visible + 14s hidden)
    const cycleInterval = setInterval(() => {
      setCurrentIndex(prevIndex => {
        const nextIndex = (prevIndex + 1) % purchases.length;
        setCurrentPurchase(purchases[nextIndex]);
        setIsVisible(true);
        // Auto-hide after 6 seconds
        setTimeout(() => {
          setIsVisible(false);
        }, 6000);
        return nextIndex;
      });
    }, 20000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(cycleInterval);
    };
  }, []);
  const handleClose = () => {
    setIsVisible(false);
  };
  return <AnimatePresence data-id="element-262">
      {isVisible && currentPurchase && <motion.div initial={{
      x: -400,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -400,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 200
    }} className="fixed bottom-6 left-6 z-50 w-[90vw] max-w-[380px]" data-id="element-263">
          <div className="bg-[#1a2332] rounded-xl shadow-2xl overflow-hidden border-b-4 border-[#00d9ff]" data-id="element-264">
            <div className="flex items-center gap-4 p-4" data-id="element-265">
              {/* Product Image */}
              <div className="flex-shrink-0" data-id="element-266">
                <img src="https://cdn.magicpatterns.com/uploads/aXmBMVfxLKsNYxRkPkGe4N/popnotification_el_divorcio_emocional_1x1.png" alt="El Divorcio Emocional" className="w-16 h-16 rounded-lg object-cover shadow-lg" data-id="element-267" />
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0" data-id="element-268">
                <div className="flex items-center gap-2 mb-1" data-id="element-269">
                  <div className="w-2 h-2 bg-[#00d9ff] rounded-full animate-pulse" data-id="element-270"></div>
                  <p className="text-sm font-semibold text-[#00d9ff]" data-id="element-271">
                    Compra Reciente
                  </p>
                </div>
                <p className="text-white font-medium mb-1 truncate" data-id="element-272">
                  {currentPurchase.name}
                </p>
                <p className="text-gray-400 text-sm" data-id="element-273">{currentPurchase.city}</p>
                <p className="text-[#00d9ff] text-xs mt-1 font-medium" data-id="element-274">
                  El Divorcio Emocional • $12.99
                </p>
              </div>

              {/* Close Button */}
              <button onClick={handleClose} className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/10 transition-colors text-gray-400 hover:text-white" data-id="element-275">
                <X className="w-4 h-4" data-id="element-276" />
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}